<template>
	<v-autocomplete
		:items="items"
		:label="label"
		:disabled="disabled"
		:multiple="multiple"
		:value="selected"
		:clearable="clearable"
		:error-count="3"
		:error-messages="errors || []"
		@input="onInput($event)"
		@change="onChange($event)"
	/>
</template>

<script>
import { tz } from 'moment-timezone'

export default {
	props: {
		errors: {
			type: Array,
			default: () => [],
		},
		disabled: Boolean,
		label: String,
		value: [String, Array],
		clearable: Boolean,
		multiple: Boolean,
		nativeName: Boolean,
	},
	computed: {
		selected() {
			return this.value
		},
		items() {
			return tz.names()
		},
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},
		onChange(event) {
			this.$emit('change', event)
		},
	},
}
</script>
